import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import Search from '../components/Search';

class UserfavouritePage extends Component {
  static propTypes = {
    userfavourite: PropTypes.array.isRequired,
    inputs: PropTypes.array.isRequired
  }

  static defaultProps = {
    userfavourite: [],
    inputs: []
  }

  render() {
    var userfavourite = this.props.userfavourite.userfavourite;
    var inputs = this.props.userfavourite.inputs;
    var SearchData = {
      'userfavourite': userfavourite,
      'inputs': inputs
    };
    return (
      <Search entities={ SearchData } />
      );
  }
}

UserfavouritePage = connectToStores(UserfavouritePage, ['UserfavouriteStore'], (stores, props) => {
  return {
    userfavourite: stores.UserfavouriteStore.get()
  };
});

export default UserfavouritePage;


// WEBPACK FOOTER //
// ./src/pages/UserfavouritePage.js